import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter, FormGroup, Label, Input,
} from "reactstrap";
import Swal from "sweetalert2";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { getRateFullList, patchBulkClientRate } from "connection/backend";

// Actions
import { rateList, rateFilter, rateDelete } from "store/rates/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Pagination from "components/Common/Pagination";
import Loader from "components/Common/Loader";

const RateList = (props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [rateIdToDelete, setRateIdToDelete] = useState(null);
  const [rateValueToDelete, setRateValueToDelete] = useState(0);
  const [errorDetail, setErrorDetail] = useState([]);
  const [selectedObjects, setSelectedObjects] = useState([]);
  const [rate, setRate] = useState("");
  const [rates, setRates] = useState([]);

  useEffect(() => {
    dispatch(rateList());
    setModal2(false);
  }, [dispatch]);

  useEffect(() => {
    if (props.rateDeleted) {
      Swal.fire({
        title: 'Tarifa eliminada',
        text: 'La tarifa ha sido eliminada exitosamente.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        dispatch(rateList());
      });
    }
  }, [props.rateDeleted, dispatch]);

  useEffect(() => {
    if (props.error && props.error.protected_objects) {
      setErrorDetail(props.error.protected_objects);
      toggleModal2();
      getRateData();
    }
  }, [props.error]);

  const params = {
    count: props.rates.count,
    next: props.rates.next,
    previous: props.rates.previous,
    results: props.rates.results,
  };

  const toggleModal = () => setModal(!modal);
  const toggleModal2 = () => setModal2(!modal2);

  const handleDeleteClick = (rateId, rateValue) => {
    setRateIdToDelete(rateId);
    setRateValueToDelete(rateValue);
    toggleModal();
  };

  const confirmDelete = () => {
    dispatch(rateDelete(rateIdToDelete));
    toggleModal();
    setSelectedObjects([]);
    setRate("");
  };

  const getRateData = async () => {
    const response = await getRateFullList();
    const data = response.data;
    setRates(data);
  };

  const onChange = (e) => {
    setRate(e.target.value);
  };

  const handleCheckboxChange = (code) => {
    setSelectedObjects(prevSelected =>
      prevSelected.includes(code)
        ? prevSelected.filter(item => item !== code)
        : [...prevSelected, code]
    );
  };

  const handleSelectAll = () => {
    if (selectedObjects.length === errorDetail.length) {
      setSelectedObjects([]);
    } else {
      setSelectedObjects(errorDetail.map(obj => obj.code));
    }
  };

  const patchClientRate = async (bulk_data) => {
    setLoading(true);
    const response = await patchBulkClientRate(bulk_data);
    setLoading(false);
    if (response.status === 200) {
      Swal.fire({
        title: 'Clientes actualizados',
        text: 'La tarifa ha sido actualizada exitosamente en los clientes seleccionados.',
        icon: 'success',
        confirmButtonText: 'OK'
      }).then(() => {
        setModal2(false);
        dispatch(rateList());
      });
    }
  };

  const handleUpdate = () => {
    console.log('Updating objects: ', selectedObjects);
    setModal2(false);
    const bulk_data = {
      "rate": rate,
      "clients": selectedObjects
    };
    patchClientRate(bulk_data);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Tarifas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Tarifas"} />
          {props.loading || loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light mb-1"
                        to="/rates/create"
                      >
                        Agregar
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.count > 0 ? (
                  <CardBody className="ps-5 pe-5">
                    <div className="table-responsive">
                      <Table
                        className="table table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                        <tr>
                          <th>Tarifa</th>
                          <th>Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {params.results.map((tarifa, idx) => (
                          <tr key={idx}>
                            <td>
                              $ {tarifa.rate_value.toLocaleString("es-CO")}
                            </td>
                            <td>
                              <Link to={`/rates/update/${tarifa.id}`}>
                                <span className="bx bx-edit fa-lg align-middle"></span>
                              </Link>{" "}
                              <button
                                style={{
                                  color: "red",
                                  backgroundColor: "transparent",
                                  border: "none",
                                }}
                                onClick={() => handleDeleteClick(tarifa.id, tarifa.rate_value)}
                              >
                                <span className="bx bx-x fa-lg align-middle"></span>
                              </button>
                            </td>
                          </tr>
                        ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={8}
                      baseUrl="rates/"
                      filterFunction={rateFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>

      <Modal
        isOpen={modal}
        toggle={toggleModal}
        centered={true}
        backdrop="static"
        size="ms"
      >
        <ModalHeader toggle={toggleModal}>Confirmar eliminación</ModalHeader>
        <ModalBody>
          ¿Está seguro/a de que desea eliminar la tarifa de <b>$ {rateValueToDelete.toLocaleString("es-CO")}</b>?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Eliminar
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={modal2}
        toggle={toggleModal2}
        centered={true}
        backdrop="static"
        size="xl"
      >
        <ModalHeader
          toggle={toggleModal2}
          className="justify-content-center"
        >
          Detalle de eliminación
        </ModalHeader>
        <ModalBody>
          <h5>La tarifa de $ {rateValueToDelete.toLocaleString("es-CO")} no se puede eliminar porque los siguientes clientes están relacionados con ella, por favor actualice la tarifa de dichos clientes para poder eliminarla.</h5>
          <Container>
            <Row className="mt-3 justify-content-between">
              <Col lg={6} className="mt-2">
                <Button color="primary" onClick={handleSelectAll} className="mt-3">
                  {selectedObjects.length === errorDetail.length ? 'Desmarcar todos' : 'Marcar todos'}
                </Button>
              </Col>
              <Col lg={3}>
                <label style={{ textAlign: 'right', marginBottom: 2.7 }}>
                  Nueva tarifa:
                </label>
                <select
                  className="form-select"
                  id="rate"
                  name="rate"
                  value={rate}
                  onChange={onChange}
                  required={true}
                >
                  <option value="" defaultValue>
                    -------
                  </option>
                  {rates.map((rate, idx) => (
                    <option key={idx} value={rate.id}>
                      {rate.rate_value.toLocaleString("es-CO")}
                    </option>
                  ))}
                </select>
              </Col>
              <Col lg={3} className="mt-2">
                <Button color="success" onClick={handleUpdate} disabled={selectedObjects.length === 0 || rate === ""} className="mt-3">
                  Actualizar tarifas
                </Button>
              </Col>
            </Row>
            <br/>
            <Row>
              {errorDetail.map(obj => (
                <Col md={6} key={obj.code} className="mb-2">
                  <FormGroup check>
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={selectedObjects.includes(obj.code)}
                        onChange={() => handleCheckboxChange(obj.code)}
                      />
                      <b>{obj.code}</b> - {obj.full_name}
                    </Label>
                  </FormGroup>
                </Col>
              ))}
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => toggleModal2()}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, rates, rateDeleted } = state.Rate;
  return { error, loading, rates, rateDeleted };
};

export default withRouter(connect(mapStateToProps)(RateList));
